











































































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import ContentType from "@/models/porposal/contentTeype.Model";
import GenericEdit from '../../../core/Generics/GenericEdit';
@Component
export default class ContentTypeEdit extends GenericEdit<ContentType> {
 
  constructor() {
    super();
    this.controller = "ContentTypes";
     this.model = new ContentType();
  }
}
